import { PosterCreatePage } from "@/features/poster/pages/PosterCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/poster/create")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["poster.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PosterCreatePage,
});
